import { render, staticRenderFns } from "./ReferencesAccordion.vue?vue&type=template&id=60ceb384&scoped=true&"
import script from "./ReferencesAccordion.vue?vue&type=script&lang=ts&"
export * from "./ReferencesAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./ReferencesAccordion.vue?vue&type=style&index=0&id=60ceb384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ceb384",
  null
  
)

export default component.exports